export const staff = [
  {
    id: 1,
    name: "Ms. Charity Katotobwe",
    title: "Executive Director",
    bio: "A Certified Chartered Accountant, MBA Graduate, and PhD candidate, Charity founded the Food and Nutrition Foundation in 2005 and began operations in December 2008 in Kamanga Compound, Lusaka. Her driving belief — Everyone is entitled to a dignified existence irrespective of socio-economic status.",
    contact: true,
    phone: "+27 65 385 5857",
    email: "chariy.katotobwe@foodnutritionfoundation.com",
    image: "/images/charity-katotobwe.jpg",
    location: "South Africa (Secretariat)",
  },
  {
    id: 2,
    name: "Ms. Thuli Zulu",
    title: "Programme Coordinator",
    bio: "Our Programme Coordinator oversees the day-to-day delivery of all four programme pillars — managing volunteers, caregivers, and the kitchen team to ensure every commitment we make is honoured.",
    contact: true,
    // phone: "+27 82 330 2294",
    email: "thuli.zulu@foodnutritionfoundation.com",
    image: "/images/thuli-zulu.jpg",
    location: "South Africa",
  },
  {
    id: 3,
    name: "Ms. Ncane Macamo",
    title: "Social Auxiliary Work Volunteer",
    bio: "Our ECD teacher leads the community preschool for children aged 3 to 6, bringing a structured, nurturing curriculum to every session. Their work since 2018 has shaped dozens of children who have entered Grade 1 confident and ready to learn.",
    contact: true,
    email: "ncane.macamo@foodandnutritionfoundation.com",
    image: "/images/ncane-macamo.jpg",
    location: "South Africa",
  },
  {
    id: 4,
    name: "Ms. Monica Schmitt",
    title: "Kamanga Center Administrator",
    bio: "Our Kamanga Center adminisrator leads the daily administrative tasks at the center, managing the center upkeep, daily activities, functions and events that take place at the center and the overall wellbeing the the Kamanga Center.",
    contact: false,
    // phone: "+260  97 8360000",
    image: "/images/monica-schmitt.jpg",
    location: "Zambia",
  },
  {
    id: 5,
    name: "Makosa Sikazwe",
    title: "Admin Desk",
    bio: "Makosa keeps the Foundation's daily operations running smoothly — managing correspondence, records, and the front desk so the rest of the team can focus on the communities we serve.",
    contact: false,
    image: "/images/makosa-sikazwe.jpg",
    location: "South Africa",
  },
];

export const volunteers = [
  {
    id: 1,
    name: "Lunga Center Volunteer",
    title: "Lunga Centre Coordinator",
    bio: "Based at our training centre under construction in Lunga, this volunteer supports day-to-day operations on the ground — liaising with the local community, coordinating logistics for the centre's construction, and helping organise workshops and activities as the site comes online.",
    image: "/images/lunga-volunteer-01.jpg",
  },
  {
    id: 2,
    name: "Malawi Center Volunteer",
    title: "Programme Volunteer — Malawi",
    bio: "Representing the Foundation's growing presence in Malawi, this volunteer helps extend our nutrition, education, and care programmes to communities beyond Zambia and South Africa.",
    image: "/images/malawi-volunteer-01.jpg",
  },
  {
    id: 3,
    name: "Home-Based Care Team",
    title: "10 Community Caregivers",
    bio: "Ten trained community caregivers visit people living with HIV/AIDS across Kamanga Compound every week — providing hands-on care, food hampers, first aid, and the simple but vital gift of human presence.",
    image: "/images/profile.jpg",
  },
  {
    id: 4,
    name: "Kitchen Volunteers",
    title: "Feeding Programme Volunteers",
    bio: "Our kitchen volunteer team arrives four mornings a week to prepare and serve meals for the community. Their consistency and dedication is the backbone of 12,600+ meals served every year.",
    image: "/images/profile.jpg",
  },
];

export const board = [
  {
    id: 1,
    name: "Tracy Breadmore Lammas",
    title: "Board Member",
    bio: "Tracy's work experience spans community development, community and adult education, and community regeneration. She has worked as a Volunteer School Governor, VSO, and a Trustee and Chair for a Mental Health Charity. She currently volunteers as a Director for a trading subsidiary of a local Mental Health Charity. Tracy works for Domestic Abuse Service, a charity that supports victims and their families, helping them understand their situation and take steps toward a brighter and healthier future. She has vast experience developing community educational opportunities for adults across South Wales, and has also worked with young people leaving care and older people at risk of isolation and loneliness. Tracy is a mother and grandmother who loves spending her spare time with them in her garden, swimming, and catching up with friends. She is looking forward to further supporting the Food and Nutrition Foundation as she takes up her new role as a board member.",
    image: "/images/profile.jpg",
  },
  {
    id: 2,
    name: "Dr. Mukuka Mulenga-Hagane",
    title: "Board Member",
    bio: "Dr Mukuka Mulenga-Hagane is a Lecturer, Researcher and Consultant at Zambia's prestigious university, The University of Zambia. Her research interests are in education and development, education law, and HIV/AIDS issues in education. Dr Hagane believes in value and relevance. She is sincere, funny, humane, and lives in pursuit of all that is pure.",
    image: "/images/profile.jpg",
  },
  {
    id: 3,
    name: "Katherine Mwila Kabaso",
    title: "Board Member",
    bio: "Mwila Katherine Kabaso is a Play Therapist with over 20 years of work experience. She holds a diploma in child psychology and certificates in child counselling and portage, a programme working with special needs children in their home settings. Katherine volunteered to work at the Archie Hinchcliffe Disability Initiative (AHDI), an organisation that works with disabled children. She has a passion for children, and it gives her so much joy to see children learn new skills daily, putting smiles on their parents' faces.",
    image: "/images/profile.jpg",
  },
  // {
  //   id: 4,
  //   name: "Board Member",
  //   title: "Board Member",
  //   bio: "Information for this board member will be added soon.",
  //   image: "/images/profile.jpg",
  // },
];
